import React, { createContext, ReactNode, useContext, useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { apiModulo } from '../services/api';
import { useModal } from '../hooks/ModalContext';
import { DadosChamada3CType, DadosChamadaType } from '../components/Discador/types';

interface HibridoContextProviderProps {
  children: ReactNode;
}

export interface DadosChamadaProps {
  nome: string;
  cpf_cnpj: string;
  contact: string;
}

interface HibridoContextProps {
  dadosChamada: DadosChamada3CType;
  setDadosChamada: React.Dispatch<React.SetStateAction<DadosChamada3CType>>;
  setContagem: React.Dispatch<React.SetStateAction<string>>;
  contagem: string;
}

const HibridoContext = createContext<HibridoContextProps>({} as HibridoContextProps);

export const HibridoProvider = ({ children }: HibridoContextProviderProps) => {
  const [dadosChamada, setDadosChamada] = useState({} as DadosChamada3CType);
  const [contagem, setContagem] = useState('00:00:00');

  return (
    <HibridoContext.Provider value={{ dadosChamada, setDadosChamada, contagem, setContagem }}>
      {children}
    </HibridoContext.Provider>
  );
};

export const useHibrido = () => useContext(HibridoContext);
